<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isNil } from 'lodash';

export default {
  name: 'VNodes',

  mixins: [HotelmeisterMixin],
  props: {
    vnodes: {
      required: false,
      type: Array,
    },
    scopedVnodes: {
      required: false,
      type: Function,
    },
    data: {
      required: false,
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
    };
  },

  render: function (h, ctx) {
    if (isNil(this.vnodes) && !isNil(this.scopedVnodes)) {
      return this.scopedVnodes(this.data);
    } else if (!isNil(this.vnodes)) {
      if (!isNil(this.vnodes) && this.vnodes.length === 1) {
        return this.vnodes[0];
      } else {
        return h('div', {}, this.vnodes);
      }
    } else {
      return h();
    }
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/lib/util/VNodes.vue